import { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input, Modal, Space, Switch, Table, Tag, Upload, message } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import NetworkApi from "../../network/networkApi";
import config from "../../config";

const empty = { information: "", title: "", documentDate: null, link: "", sortOrder: 0, isVisible: true };

const LoginRuleList = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [editing, setEditing] = useState<any>(null);
  const [form] = Form.useForm();

  const load = async () => {
    const response = await NetworkApi.requestGet("/api/admin/login-rule/list");
    if (response.resultCode === 200) setRows(Array.isArray(response.result) ? response.result : []);
    else message.error(response.message || "Жагсаалт татахад алдаа гарлаа");
  };

  useEffect(() => { load(); }, []);

  const open = (row?: any) => {
    setEditing(row || {});
    form.setFieldsValue(row ? { ...row, documentDate: moment(row.documentDate) } : empty);
  };

  const save = async (values: any) => {
    let imageName = editing?.imageName || null;
    let imageMimeType = editing?.imageMimeType || null;
    const file = values.image?.[0]?.originFileObj;
    if (file) {
      if (!file.type.startsWith("image/")) return message.error("Зөвхөн зураг хавсаргана уу");
      const upload = await NetworkApi.requestUploadFile(file);
      if (upload.resultCode !== 200) return message.error(upload.message || "Зураг хуулахад алдаа гарлаа");
      imageName = upload.result.name;
      imageMimeType = upload.result.mimetype;
    }
    const body = { ...values, image: undefined, imageName, imageMimeType, documentDate: values.documentDate.format("YYYY-MM-DD") };
    const response = editing?.id
      ? await NetworkApi.requestPut(`/api/admin/login-rule/${editing.id}`, body)
      : await NetworkApi.requestPost("/api/admin/login-rule", body);
    if (response.resultCode !== 200) return message.error(response.message || "Хадгалахад алдаа гарлаа");
    message.success("Амжилттай хадгалагдлаа");
    setEditing(null);
    form.resetFields();
    load();
  };

  const remove = (row: any) => {
    Modal.confirm({
      title: "Устгах уу?",
      content: row.title,
      okText: "Устгах",
      cancelText: "Болих",
      okButtonProps: { danger: true },
      onOk: async () => {
        const response = await NetworkApi.requestDelete(`/api/admin/login-rule/${row.id}`);
        if (response.resultCode !== 200) return message.error(response.message || "Устгахад алдаа гарлаа");
        message.success("Амжилттай устгагдлаа");
        load();
      },
    });
  };

  const columns = [
    { title: "№", render: (_: any, __: any, index: number) => index + 1, width: 60 },
    { title: "Зураг", dataIndex: "imageName", render: (value: string) => value ? <img src={`${config.get("apiUrl")}/tmp/${value}`} alt="" style={{ width: 70, height: 42, objectFit: "cover" }} /> : "-" },
    { title: "Мэдээлэл", dataIndex: "information" },
    { title: "Гарчиг", dataIndex: "title" },
    { title: "Огноо", dataIndex: "documentDate", render: (value: string) => moment(value).format("YYYY-MM-DD") },
    { title: "Дараалал", dataIndex: "sortOrder" },
    { title: "Төлөв", dataIndex: "isVisible", render: (value: boolean) => <Tag color={value ? "green" : "default"}>{value ? "Харуулна" : "Нуусан"}</Tag> },
    { title: "Үйлдэл", render: (_: any, row: any) => <Space><Button icon={<EditOutlined />} onClick={() => open(row)}>Засах</Button><Button danger icon={<DeleteOutlined />} onClick={() => remove(row)}>Устгах</Button></Space> },
  ];

  return <div style={{ padding: 24 }}>
    <Space style={{ marginBottom: 16 }}><h2 style={{ margin: 0 }}>Дүрэм журам, тушаал шийдвэр</h2><Button type="primary" icon={<PlusOutlined />} onClick={() => open()}>Нэмэх</Button></Space>
    <Table rowKey="id" columns={columns} dataSource={rows} />
    <Modal title={editing?.id ? "Засах" : "Нэмэх"} visible={editing !== null} onCancel={() => setEditing(null)} onOk={() => form.submit()} width={700} destroyOnClose>
      <Form form={form} layout="vertical" initialValues={empty} onFinish={save}>
        <Form.Item name="information" label="Мэдээлэл"><Input.TextArea rows={2} placeholder="Тушаалын өмнө харагдах мэдээлэл" /></Form.Item>
        <Form.Item name="image" label="Зураг" valuePropName="fileList" getValueFromEvent={(event: any) => event?.fileList || []}>
          <Upload beforeUpload={() => false} maxCount={1} accept="image/png,image/jpeg,image/jpg,image/gif">
            <Button icon={<UploadOutlined />}>Зураг сонгох</Button>
          </Upload>
        </Form.Item>
        <Form.Item name="title" label="Гарчиг" rules={[{ required: true, message: "Гарчиг оруулна уу" }]}><Input.TextArea rows={3} /></Form.Item>
        <Form.Item name="documentDate" label="Огноо" rules={[{ required: true, message: "Огноо сонгоно уу" }]}><DatePicker /></Form.Item>
        <Form.Item name="link" label="Холбоос" rules={[{ required: true, message: "Холбоос оруулна уу" }, { type: "url", message: "Зөв холбоос оруулна уу" }]}><Input placeholder="https://..." /></Form.Item>
        <Form.Item name="sortOrder" label="Дараалал"><Input type="number" /></Form.Item>
        <Form.Item name="isVisible" label="Нэвтрэх хуудсанд харуулах" valuePropName="checked"><Switch /></Form.Item>
      </Form>
    </Modal>
  </div>;
};

export default LoginRuleList;
